import React from 'react';
import { Main } from '@klp/layout/Main';
import { useTranslation } from 'react-i18next';
import { reportMappingRoutes } from '../config';
import { Heading } from '@klp/design/Heading';
import { makeStyles } from '@material-ui/core';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { MappingTable } from '../components/MappingTable/MappingTable';
import { MappingSummary } from '../components/MappingSummary';

const useStyles = makeStyles((theme) => ({
    titleHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
    },
}));

import { Link } from '@klp/design/Link';

export const ReportMappingView = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Main>
            <Main.Breadcrumbs>
                <Main.Crumb
                    id="reportMapping"
                    label={t('reportMapping.breadcrumbs.reportMapping')}
                    href={reportMappingRoutes.moduleRoute()}
                />
            </Main.Breadcrumbs>

            <div className={classes.titleHeader}>
                <Heading translation="reportMapping.menu.title" />

                <Link
                    href={reportMappingRoutes.documentationRoute()}
                    underline="hover"
                    translation="reportMapping.documentation.title"
                    endIcon={<Illustration icon={IconName.CIRCLE_INFO} />}
                />
            </div>

            <div className={classes.contentContainer}>
                <MappingSummary />
                <MappingTable />
            </div>
        </Main>
    );
};
